import { render } from "./GridContracteMunca.vue?vue&type=template&id=bc96a4bc&ts=true"
import script from "./GridContracteMunca.vue?vue&type=script&lang=ts"
export * from "./GridContracteMunca.vue?vue&type=script&lang=ts"

import "./GridContracteMunca.vue?vue&type=style&index=0&id=bc96a4bc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__